interface ArrowProps {
  size?: number;
  color?: string;
  direction?: 'right' | 'down' | 'left' | 'top';
  className?: string;
}

export function Arrow({
  size = 16,
  direction = 'right',
  className = '',
}: ArrowProps) {
  const rotationMap: Record<string, number> = {
    down: 0, // base
    left: 90,
    right: -90,
    top: 180,
  };

  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 16 16'
      xmlns='http://www.w3.org/2000/svg'
      style={{
        transform: `rotate(${rotationMap[direction]}deg)`,
        transformOrigin: 'center',
      }}
      className={className}
    >
      <path
        d='M8.00032 1L10.6703 1C13.9803 1 15.3403 3.35 13.6803 6.22L12.3403 8.53L11.0003 10.84C9.34032 13.71 6.63032 13.71 4.97032 10.84L3.63032 8.53L2.29032 6.22C0.660322 3.35 2.01032 1 5.33032 1L8.00032 1Z'
        fill='currentColor'
      />
    </svg>
  );
}
